import { Check, Trash2 } from 'lucide-react';
import { Card, Tooltip } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import WidgetLibraryAvatar from './WidgetLibraryAvatar';
import DashboardButton from './DashboardButton';

const WidgetLibraryListCard = ({
  widget,
  isSelected,
  disabled = false,
  disabledTooltip,
  onCardToggle,
  onCardKeyDown,
  onActionButtonClick,
}) => {
  const { t } = useTranslation('dashboards');
  return (
    <Tooltip content={disabledTooltip} disabled={!disabled} size="compact" triggerClassName="flex h-full w-full">
    <Card
    role="button"
    tabIndex={disabled ? -1 : 0}
    aria-pressed={isSelected}
    aria-disabled={disabled || undefined}
    onClick={onCardToggle(widget)}
    onKeyDown={onCardKeyDown(widget)}
    className={`h-full w-full rounded-xl border-[1.5px] shadow-none outline-none transition-colors focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-surface ${
      disabled
        ? 'cursor-not-allowed border-edge-strong opacity-50 dark:border-edge'
        : 'cursor-pointer'
    } ${
      !disabled && isSelected
        ? '!border-brand-500 bg-brand-50/20 dark:bg-brand-950/35'
        : ''
    } ${
      !disabled && !isSelected
        ? 'border-edge-strong hover:border-brand-300/60 dark:border-edge dark:hover:border-brand-600/40'
        : ''
    }`}
  >
    <div className="relative flex h-full min-h-0 flex-col p-3">
      <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5">
        <div className="flex min-h-0 items-center justify-center">
          <WidgetLibraryAvatar widget={widget} selected={isSelected} />
        </div>
        <div className="min-w-0">
          <h4 className="truncate text-sm font-semibold leading-tight text-content" title={widget.name}>{widget.name}</h4>
          {isSelected && (
            <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-emerald-600 dark:text-emerald-400">
              <Check size={12} aria-hidden />
              {t('widgetLibrary.detail.selected')}
            </p>
          )}
        </div>
        <p className="col-span-2 line-clamp-3 text-xs leading-snug text-content-muted">
          {widget.description}
        </p>
      </div>
      <div className="mt-auto flex justify-end pt-3">
        <DashboardButton
          type="button"
          variant="secondary"
          size="sm"
          tabIndex={disabled ? -1 : undefined}
          aria-disabled={disabled || undefined}
          className={`!h-7 shrink-0 !rounded-md !gap-1 !px-2.5 !py-0 ${disabled ? 'pointer-events-none' : ''}`}
          onClick={onActionButtonClick(widget)}
        >
          {isSelected ? (
            <>
              <Trash2 size={14} aria-hidden />
              {t('actions.remove')}
            </>
          ) : (
            `+ ${t('actions.add')}`
          )}
        </DashboardButton>
      </div>
    </div>
    </Card>
    </Tooltip>
  );
};

export default WidgetLibraryListCard;
